import {Injectable, TemplateRef} from "@angular/core";
import {FUIFormationGroupComponent} from "./formation-groups/formation-group/formation-group.component";
import {Observable} from "rxjs";
import {ReplaySubject} from "rxjs";
import {AbstractControl, FormControl, FormGroup} from "@angular/forms";
import {FUIFormationType} from "./formation.type";
import {BehaviorSubject} from "rxjs";

export class GroupTemplate {
    title: string;
    visible: boolean | Promise<boolean>;
    formControlNames: string[] | string;
    template: TemplateRef<any>;
    formationType: FUIFormationType;
    formationClass: string;

    constructor(title: string, visible: boolean | Promise<boolean>, formControlNames: string[] | string, formationType: FUIFormationType, formationClass: string, template: TemplateRef<any>) {
        this.title = title;
        this.visible = visible;
        this.formControlNames = formControlNames;
        this.template = template;
        this.formationClass = formationClass;
        this.formationType = formationType;
    }
}

@Injectable()
export class FUIFormationService {
    private _groups: ReplaySubject<Array<FUIFormationGroupComponent>> = new ReplaySubject<Array<FUIFormationGroupComponent>>(1);
    public groups$: Observable<Array<FUIFormationGroupComponent>> = this._groups.asObservable();
    private _group: ReplaySubject<FUIFormationGroupComponent> = new ReplaySubject<FUIFormationGroupComponent>(1);
    public group$: Observable<FUIFormationGroupComponent> = this._group.asObservable();
    private _groupTemplates: ReplaySubject<GroupTemplate[]> = new ReplaySubject<GroupTemplate[]>(1);
    public groupTemplates$: Observable<GroupTemplate[]> = this._groupTemplates.asObservable();
    private _initialised: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
    public initialised$: Observable<boolean> = this._initialised.asObservable();

    private _listGroups: Array<FUIFormationGroupComponent> = [];

    private listGroupTemplates: GroupTemplate[] = [];

    public formGroupValidation: FormGroup;

    public formSubmitted: Observable<boolean>

    public formationType: FUIFormationType = FUIFormationType.NON_COLLAPSIBLE;

    /**
     * Function that can be override to return content-layout controls for an group
     * @param {FormGroup} formGroup
     */
    public formGroupResolver: (formGroup: FormGroup) => AbstractControl[] =
        function (formGroup: FormGroup): AbstractControl[] {
            const controls: AbstractControl[] = [];
            for (const key in formGroup.controls) {
                if (formGroup.controls[key] instanceof FormControl) {
                    controls.push(formGroup.controls[key]);
                }
            }
            return controls;
        };

    notifyInitialised(): void {
        this._initialised.next(true);
    }

    setActiveGroup(group: FUIFormationGroupComponent): void {
        this._group.next(group);
    }

    /**
     * Register a group
     * @param group
     */
    registerGroup(group: FUIFormationGroupComponent): void {
        this._listGroups.push(group);
        this._groups.next(this._listGroups);
    }

    /**
     * Unregister a group
     * @param group
     */
    unregisterGroup(group: FUIFormationGroupComponent): void {
        this._listGroups = this._listGroups.filter(registeredGroup => registeredGroup !== group);
        this._groups.next(this._listGroups);
    }

    registerGroupTemplate(title: string,
                          visible: boolean | Promise<boolean>,
                          formControlNames: string[] | string,
                          formationType: FUIFormationType,
                          formationClass: string,
                          template: TemplateRef<any>): void {
        let i: number = this.listGroupTemplates.findIndex(registeredGroupTemplate => registeredGroupTemplate.title === title);
        if(i == -1) {
            i = this.listGroupTemplates.length;
        }
        this.listGroupTemplates.splice(i, 1, new GroupTemplate(title, visible, formControlNames, formationType, formationClass, template));
        this._groupTemplates.next(this.listGroupTemplates);
    }

    unregisterGroupTemplate(title: string): void {
        let i: number = this.listGroupTemplates.findIndex(registeredGroupTemplate => registeredGroupTemplate.title === title);
        if(i !== -1) {
            this.listGroupTemplates.splice(i, 1);
            this._groupTemplates.next(this.listGroupTemplates);
        }
    }

    /**
     * Returns a list of all formation groups
     * @returns {Array<FUIFormationGroupComponent>}
     */
    get listGroups(): Array<FUIFormationGroupComponent> {
        return this._listGroups;
    }
}
